import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import ShareIcon from "@mui/icons-material/Share";
import {
  getRoutesAPI,
  getRoutesAssignedAPI,
  shareRoute,
} from "../../../../services/rest/routes/routesServices";
import { handleError } from "../../../../utils/handleError";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import {
  setlistRoutes,
  setListRoutesAssigned,
} from "../../../../redux/slice/routeSlice";
import { filterRoutesOfMembership } from "../../../../utils/FilterRoutesOfMembership";

const ModalShareRoute = ({ open, setOpen, setLoading, selectedRoute }) => {
  const { lastPayment, nextPayment } = useSelector(
    (state) => state.membershipReducer
  );
  const dispatch = useDispatch();
  const handleShareRoute = async () => {
    try {
      setLoading(true);
      await shareRoute(selectedRoute?._id);
      const routes = await getRoutesAPI(); //peticion a todas las rutas
      const routesAssigned = await getRoutesAssignedAPI(); // peticion a rutas asignadas

      dispatch(
        setListRoutesAssigned({ listRoutesAssigned: routesAssigned ?? [] })
      );
      const totalRoutes = [...routes, ...routesAssigned];
      const routesOfMembership = filterRoutesOfMembership(
        { paymentDate: lastPayment, expiresDateMembership: nextPayment },
        totalRoutes ?? []
      );

      dispatch(
        setlistRoutes({
          listRoutes: routes ?? [],
          totalOfRoutesMembership: routesOfMembership ?? 0,
        })
      );
      setOpen(false);
      setLoading(false);
      toast.success("Su ruta se compartió con éxito");
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      toast.error(
        "En este momento no se pudo compartir tu ruta.",
        `${message}`
      );
    }
  };
  return (
    <Dialog open={open}>
      <DialogContent sx={{ padding: 5 }}>
        <DialogTitle sx={{ textAlign: "center" }}>
          ¿Estas seguro de compartir la ruta {selectedRoute?.nameRoute} con la
          comunidad de Radaria?
        </DialogTitle>
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="outlined"
            onClick={handleShareRoute}
            sx={{ borderColor: "white", color: "white" }}
            startIcon={<ShareIcon />}
          >
            Compartir ruta
          </Button>
          <Button
            variant="contained"
            onClick={() => setOpen(false)}
            sx={{ backgroundColor: "#e7ef7d" }}
            startIcon={<CancelIcon />}
          >
            Cerrar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ModalShareRoute;
